var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"users"},[_c('list',{attrs:{"data":{
            list: _vm.list,
            pagination: _vm.pagination,
            hasLoading: _vm.hasLoading,
            headers: [
                {
                    type: 'component',
                    value: 'contacts',
                    component: function () { return import( /* webpackChunkName: 'BaseContacts' */ '@/components/bundles/contacts/BaseContacts' ); }
                },
                { type: 'default', value: 'role', isNecessaryTranslate: true },
                {
                    type: 'component',
                    translate: 'state',
                    value: 'id',
                    component: function () { return import( /* webpackChunkName: 'BaseStates' */ '@/components/bundles/states/BaseStates' ); }
                }
            ],
            destak: 'name'
        }}}),_c('widget-options')],1)}
var staticRenderFns = []

export { render, staticRenderFns }